import { createProductExtensions } from './utils';
export var recommendationContextExtensionsWhitelist = ['recommendationContext'];
export var createRecommendationContextExtensions = function createRecommendationContextExtensions(options) {
  return createProductExtensions(recommendationContextExtensionsWhitelist)({
    recommendationContext: options
  });
};